'use strict';

var trackingUtils = require('../../modules/utils/tracking.utils');
var summaryLabelMixin = require('../../modules/views/results/summary_label');

var addSelectorToCache = function(name, selector) {
    this.$cachedSelectors[name] = this.$el.find(selector);
};

module.exports = Backbone.View.extend({
    name: 'filter_tag',
    events: {
        'click .reset_filter_tag': 'turnOff',
    },
    initialize: function(options) {
        summaryLabelMixin.initialize.call(this, options);
        this.listenTo(this.model, 'clear', this.turnOff);
        this.getTrackingLabelType = options.getTrackingLabelType;
    },
    turnOff: function() {
        var model = this.model;
        model.set('active', false);
        trackingUtils.trackEvent('results_filters', 'remove_filter_' + this.getTrackingLabelType());
        Odigeo.trigger(this.name + ':filtersLoading');
        Odigeo.trigger(this.name + ':resetFilter', model.get('filterName'), model.get('index'), model.get('data').toJSON());
    },
    render: function() {
        this.$el.html(this.template());
        addSelectorToCache.call(this, 'content', '.tag_filter_content');
        this.renderContent();
    },
    renderContent: function() {
        this.$cachedSelectors.content.html(this.contentTemplate(Odigeo._.extend(this.model.get('data').toJSON(), this.model.toJSON())));
    },
});
